class BulkOptions extends HTMLElement {
	constructor() {
		super();

		this.currentBulkProduct = null;

        this.formID = this.dataset.formId;
		this.quantity = this.querySelector('.quantity__input');
		this.quantityHidden = this.querySelector('.hidden-quantity__input');
		this.quantityButtons = this.querySelectorAll('.quantity__button')
		this.options = this.getAllOptions();
		this.updateCurrentOption();
		this.currentMainProduct = this.getCurrentJsonProduct();
		this.variantSelects = this.parentElement;
		this.currentMainVariant = this.variantSelects.currentVariant || this.currentMainProduct.variants[0] ;
		this.currentBulkProducts = this.getBulkJsonProducts();
		this.optionsParam = this.getOptionsParam();
		this.updateProductInfo();
		this.createArrayWithQuantity();

		// this.updateAddToCartButton();

		this.addEventListener('change', this.onOptionChange);
		if (this.quantityButtons.length > 0) {
			this.quantityButtons.forEach(
				(button) => button.addEventListener('click', this.onQuantityButtonClick.bind(this))
			);
		}

	}
	   onVariantChange(price) {
		   this.updatePriceDataAttr(price);
		   this.recalculatePriceOnChangeVariant(price);
		   this.onQuantityButtonClick();
	   }

	   onOptionChange() {
		this.currentMainVariant = this.variantSelects.currentVariant || this.currentMainProduct.variants[0];
		this.getOptionsParam();
		this.updateCurrentOption();
		this.updateProductInfo();
	    this.updateQuantityInput();
       

		// this.updateAddToCartButton();

		if (this.currentOption.dataset.selectType !== 'on-time') {
			this.updateBulkProductID();
			this.findBulkProduct();
			this.findBulkVariant();
			this.updateVariantInput();
		}
	}


	recalculatePriceOnChangeVariant(price) {


		this.options.forEach(option => {
			let quantity = option.dataset.quantityInfo || this.quantity.value
			let discount = option.dataset.discountInfo

			let priceContainer = option.closest('.bulk-options__item').querySelector('[data-dynamic-price]');
			let discount_money = price - (price * discount / 100)
			let finalPrice = discount_money * quantity;

			if (finalPrice && priceContainer) {
				priceContainer.innerHTML = this.formatMoney(finalPrice,'${{amount}}')
			}

			let one_time_container = document.querySelector('.bulk-options__one-time');
			let price_container = one_time_container.querySelector('[data-dynamic-price]');
			if (one_time_container && price_container) {
			price_container.innerText = this.formatMoney(price,'${{amount}}');
			}
		})
	}

	onQuantityButtonClick() {

		let priceContainer = this.querySelector('[data-calculate-price]');
		let quantity = this.quantity.value

		this.arrayQuntity = this.arrayQuntity.sort(function (a, b) {
			return a.quantity - b.quantity;
		});


		let discount = this.arrayQuntity.reverse().find(function(el) {
			return (parseInt(quantity) >= parseInt(el.quantity));
		});

		this.changePrice(discount,quantity);

		let element = document.createElement("span");
		priceContainer.querySelector('.bulk-option__price-discount')?.remove();
		if (discount) {
			element.classList.add('bulk-option__price-discount');
			element.innerText = `SAVE ${discount.discount}%`;
			priceContainer.prepend(element);
		} else  {
			priceContainer.querySelector('.bulk-option__price-discount')?.remove();
		}
	}

	changePrice(discount,quantity) {
 
		if (!quantity) {
			return
		}

       let one_time_container = document.querySelector('.bulk-options__one-time');
	   let price_container = one_time_container.querySelector('[data-dynamic-price]');
	   let price_container_old = this.querySelector('[data-old-price]');
	   let price = one_time_container.dataset.productPrice;

       let price_compare =  this.variantSelects.currentVariant.compare_at_price;

	   let price_container_compare = this.querySelector('[data-compare-price]');

		price_container_old.innerText = this.formatMoney(price * quantity,'${{amount}}');
 

       if (discount) {
		   let percent = 1 - (discount.discount * 0.01);
		   price = price * percent;
		   price_container_old.style.display = "block";
		   if( price_container_compare){
			price_container_compare.style.display = "none";
		  }
		} else if(price_container_compare){
		   price_container_compare.style.display = "block";
		   price_container_old.style.display = "none";
		   price_container_compare.innerText =  this.formatMoney(price_compare * quantity,'${{amount}}');
		} else {
		   price_container_old.style.display = "none";
		}

	   price = quantity * price;
	   price_container.innerText = this.formatMoney(price,'${{amount}}');
	}

	getCurrentJsonProduct() {
		this.currentMainProduct = this.currentMainProduct || JSON.parse(this.querySelector('[data-single-bulk]').textContent);
		return this.currentMainProduct;
	}

	getBulkJsonProducts() {
		const bulkJson = this.querySelectorAll('[data-bulk-product]');
		const arrayBulkProducts = [];


		if (bulkJson.length > 0) {
			bulkJson.forEach(json => {
				arrayBulkProducts.push(JSON.parse(json.textContent));
			})

			this.currentBulkProducts = this.currentBulkProducts || arrayBulkProducts;
			return this.currentBulkProducts;
		}
	}


	getAllOptions() {
		return Array.from(this.querySelectorAll('input[name="bulk-option"]'));
	}

	getOptionsParam() {
		this.optionsParam = this.currentMainVariant.options;
		return this.optionsParam;
	}

	updateCurrentOption() {
		this.currentOption = Array.from(this.options).find((radio) => radio.checked);
	}

	updatePriceDataAttr(price) {
		let one_time_container = document.querySelector('.bulk-options__one-time');
		one_time_container.dataset.productPrice = price;
	}

	updateBulkProductID() {
		this.bulkProductId = this.currentOption.dataset.bulkProductId;
		return this.bulkProductId;
	}

	findBulkProduct() {
		this.currentBulkProduct = this.currentBulkProducts.find(product => {
			return this.bulkProductId == product.id;
		})
	}

	findBulkVariant() {
         this.variantBulkID = this.currentBulkProduct.variants.find(variant => {
			return variant.options.reduce((a, b) => a && this.optionsParam.includes(b), true);
		 });

		 return this.variantBulkID;
	}

	updateProductInfo() {
		this.info = Object.assign({}, this.currentOption.dataset)
	}

	updateQuantityInput() {
		this.quantityHidden.value = this.info.quantityInfo
	}

	createArrayWithQuantity() {

		this.arrayQuntity = this.options.reduce((results, item) => {
			if (item.dataset.quantityInfo && item.dataset.discountInfo)
				results.push({
					quantity: item.dataset.quantityInfo,
					discount: item.dataset.discountInfo
				})
			return results
		}, [])

	}

	updateAddToCartButton() {
		// RE-DEV
		const buttonInfo = document.querySelectorAll('.product-form__custom');
		buttonInfo.forEach(button => {
				button.innerHTML = 'Add to cart&nbsp;-&nbsp;' + this.info.productPrice;
		})
	}

	updateVariantInput() {
				const productForms = document.querySelectorAll(`#${this.formID}`);
				productForms.forEach((productForm) => {
					const input = productForm.querySelector('input[name="id"]');
					input.value = this.variantBulkID.id;
					input.dispatchEvent(new Event('change', { bubbles: true }));
				});
		}

	formatMoney(cents, format) {
		if (typeof cents == 'string') { cents = cents.replace('.',''); }
		var value = '';
		var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
		var formatString = (format || this.money_format);

		function defaultOption(opt, def) {
			return (typeof opt == 'undefined' ? def : opt);
		}

		function formatWithDelimiters(number, precision, thousands, decimal) {
			precision = defaultOption(precision, 2);
			thousands = defaultOption(thousands, ',');
			decimal   = defaultOption(decimal, '.');

			if (isNaN(number) || number == null) { return 0; }

			number = (number/100.0).toFixed(precision);

			var parts   = number.split('.'),
				dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
				cents   = parts[1] ? (decimal + parts[1]) : '';

			return dollars + cents;
		}

		switch(formatString.match(placeholderRegex)[1]) {
			case 'amount':
				value = formatWithDelimiters(cents, 2);
				break;
			case 'amount_no_decimals':
				value = formatWithDelimiters(cents, 0);
				break;
			case 'amount_with_comma_separator':
				value = formatWithDelimiters(cents, 2, '.', ',');
				break;
			case 'amount_no_decimals_with_comma_separator':
				value = formatWithDelimiters(cents, 0, '.', ',');
				break;
		}

		return formatString.replace(placeholderRegex, value);
	};
}


customElements.define('bulk-options', BulkOptions);
